import type { CSSProperties } from 'react';
import { COULEURS, ESPACEMENTS, OMBRES, RAYONS, styleBase, styleCible, type Variante } from '../tokens/tokens.js';

/** Bouton principal : fond #C2410C, texte blanc (jamais l'orange décoratif). Un seul par écran côté client (UX-18). */
export function styleBoutonPrincipal(variante: Variante): CSSProperties {
  return {
    ...styleBase(variante),
    ...styleCible(variante),
    backgroundColor: COULEURS.bouton,
    color: '#FFFFFF',
    border: '2px solid transparent',
    borderRadius: RAYONS.bouton,
    padding: `${ESPACEMENTS.s}px 18px`,
    fontWeight: 600,
    cursor: 'pointer',
  };
}

/** Bouton secondaire : contour marine sur fond blanc. */
export function styleBoutonSecondaire(variante: Variante): CSSProperties {
  return {
    ...styleBase(variante),
    ...styleCible(variante),
    backgroundColor: COULEURS.fond,
    color: COULEURS.marine,
    border: `1px solid ${COULEURS.marine}`,
    borderRadius: RAYONS.bouton,
    padding: `${ESPACEMENTS.s}px 18px`,
    fontWeight: 600,
    cursor: 'pointer',
  };
}

/** Texte réservé aux lecteurs d'écran (annonce d'un état que la couleur ne porte pas seule). */
export const STYLE_MASQUE_VISUELLEMENT: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};

/** Fenêtre modale : voile sombre qui couvre la page. */
export const STYLE_VOILE: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: ESPACEMENTS.m,
  backgroundColor: 'rgba(31, 35, 71, 0.65)',
  zIndex: 2000,
};

export function styleBoiteModale(variante: Variante): CSSProperties {
  return {
    ...styleBase(variante),
    backgroundColor: COULEURS.fond,
    border: `1px solid ${COULEURS.bordureForte}`,
    borderRadius: RAYONS.carte,
    boxShadow: OMBRES.fenetre,
    padding: ESPACEMENTS.l,
    width: '100%',
    maxWidth: 560,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: ESPACEMENTS.m,
  };
}
